import * as React from 'react';
import { Container } from '@meraki-internal/dependency-injection';

interface IContainerContext {
    container: Container | null
}

export const DependencyContainerReactContext = React.createContext<IContainerContext>({ container: null });
